<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pNPbtW/tc-custom/9781960436535.jpg?1731381766916" alt="This image is the cover for the book Los principios de Jesús"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Los principios de Jesús
      </h1>
      <p class="bookDescription body article font2">
        <p>Vive una vida que ni la muerte puede detener Tu mayor ministerio es hacia las personas que te rodean. La verdadera influencia debería aumentar a través de las vidas de aquellos en quienes has invertido, incluso después de que hayas fallecido. Nuestro mejor ejemplo de esto es Jesús. Él nunca escribió un libro ni viajó fuera de Israel, pero pudo utilizar a un grupo de once seguidores para crear el movimiento más grande y más influyente que el mundo haya visto. Jesús no tenía sirvientes, sin embargo, lo llamaban Maestro. No tenía medicinas, sin embargo, lo llamaban Sanador. No tenía un ejército, sin embargo, los reyes lo temían. No ganó batallas militares, sin embargo, conquistó el mundo. No cometió ningún crimen, sin embargo, lo crucificaron. Fue enterrado en una tumba, sin embargo, vive hoy. Además, los seguidores de Jesús hicieron obras aún más grandes después de que Él los dejara. Los libros de Mateo, Marcos, Lucas y Juan no solo son compilaciones de narrativa sagrada sobre la vida de Jesús, sino que también contienen principios que nos permiten pasar del potencial al cumplimiento del propósito. En Los Principios de Jesús, Joseph Mattera te ayuda a desatar la grandeza en ti mismo, pero aún más importante, en tu círculo de influencia: tu cónyuge, hijos, amigos y familia. Deja un legado de ayudar a otros a alcanzar su propio potencial para que después de tu partida, aún sigas hablando. Conviértete en parte de una gran nube de testigos que ayudan a liberar el llamado divino en los demás.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Mattera
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0707a9ac